var REGISTRATION_EVENT = 'Registration';
/**
 * Add event trigger for GTM tracking tags
 *
 * @param {String} eventName
 * @returns {Array}
 */

function dataLayerPush(eventName) {
  /* eslint no-undef: 0 */
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName
  });
  return window.dataLayer;
}

export { REGISTRATION_EVENT, dataLayerPush };
